// extracted by mini-css-extract-plugin
export var container = "hero-module--container--AKhQP";
export var absolute = "hero-module--absolute--o+47g";
export var imageContainer = "hero-module--imageContainer--ZIsaQ";
export var image = "hero-module--image--j1pDP";
export var gradient = "hero-module--gradient--D-Rkc";
export var textContainer = "hero-module--textContainer--J+-9f";
export var date = "hero-module--date--nAfT+";
export var tagsContainer = "hero-module--tagsContainer--FVf0D";
export var tag = "hero-module--tag--o39S2";